import { useState, useEffect, useRef } from "react";
import {
  MobileTournamentStructureItem,
  MobileTournamentStructureTable,
  MobileTournamentStructureHeader,
  MobileTournamentStructureItemBrake,
  MobileTournamentStructureItemWrapper,
} from "./style";
import {
  MobileTournamentITMBack,
  MobileTournamentITMHeader,
  MobileTournamentITMWrapper,
} from "../itm/style";
import { TournamentResponse } from "../../../../../../api/tournament";
import { StructuresResponse } from "../../../../hook/useEditTournament";

const MobileTournamentMoreStructure = ({
  tournament,
}: {
  tournament: TournamentResponse | null;
}) => {
  const [list, setList] = useState<StructuresResponse[]>([]);
  const [open, setOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(open ? contentRef.current.scrollHeight + 56 + 20 : 56);
    }
  }, [open]);

  useEffect(() => {
    if (!tournament) return;
    setList(tournament.structure);
  }, [tournament]);

  return (
    <MobileTournamentITMWrapper contentHeight={contentHeight}>
      <MobileTournamentITMHeader onClick={() => setOpen(!open)} open={open}>
        <div className="title">스트럭쳐</div>
        <img src="image-web/icon/down_arrow.svg" alt="more" />
      </MobileTournamentITMHeader>
      <MobileTournamentITMBack open={open} ref={contentRef}>
        <MobileTournamentStructureTable>
          <MobileTournamentStructureHeader>
            <div className="level">LV</div>
            <div className="blind">SB</div>
            <div className="blind">BB</div>
            <div className="item">ANTE</div>
            <div className="item">TIME</div>
          </MobileTournamentStructureHeader>
          <MobileTournamentStructureItemWrapper>
            {list.map((item, index) =>
              item.type === "LEVEL" ? (
                <MobileTournamentStructureItem key={index}>
                  <div className="level">{item.level}</div>
                  <div className="blind">
                    {item.smallBlind?.toLocaleString()}
                  </div>
                  <div className="blind">{item.bigBlind?.toLocaleString()}</div>
                  <div className="item">{item.ante?.toLocaleString()}</div>
                  <div className="item">{item.time}</div>
                </MobileTournamentStructureItem>
              ) : (
                <MobileTournamentStructureItemBrake key={index}>
                  <div className="item">BREAK {item.time} MIN</div>
                </MobileTournamentStructureItemBrake>
              ),
            )}
          </MobileTournamentStructureItemWrapper>
        </MobileTournamentStructureTable>
      </MobileTournamentITMBack>
    </MobileTournamentITMWrapper>
  );
};

export default MobileTournamentMoreStructure;
